import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from '@angular/forms';
import { EmailValidators } from '@zero/shared/util-form-validators';

@Directive({
  selector: '[zeroEmailOrUser]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailOrUserDirective, multi: true }],
  standalone: true,
})
export class EmailOrUserDirective implements Validator, OnChanges {
  @Input() public zeroEmailOrUser: boolean;
  @Input() public zeroEmailOrUserAllowUser = true;

  readonly #userNameValidator = Validators.pattern('[a-zA-Z0-9]{6,}');

  #onChange: () => void;

  public validate(c: AbstractControl): ValidationErrors | null {
    if (typeof this.zeroEmailOrUser !== 'undefined' && this.zeroEmailOrUser === false) {
      return null;
    }

    const inputValue: string = c.value || '';
    if (inputValue.trim() !== inputValue) {
      c.setValue(inputValue.trim());
    }

    let validationErrors = null;
    if (EmailValidators.emailValidator()(c) != null && (this.zeroEmailOrUserAllowUser === false || this.#userNameValidator(c) != null)) {
      validationErrors = {
        emailOrUser: true,
      };
    }
    if (EmailValidators.emailValidator()(c) == null) {
      const controlValue: string = c.value || '';
      if (controlValue !== controlValue.toLowerCase()) {
        c.setValue(controlValue.toLowerCase());
      }
    }
    return validationErrors;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('zeroEmailOrUser' in changes) {
      if (this.#onChange) {
        this.#onChange();
      }
    }
  }

  /**
   * Verwendung von registerOnValidatorChange:
   * https://medium.com/front-end-weekly/angular-how-to-implement-conditional-custom-validation-1ec14b0feb45
   * (die Callback-Fn kann man aufrufen, um eine erneute Validierung auszulösen. Wir machen das hier,
   * wenn sich der Wert der Input-Value der Directive, also "zeroEmailOrUser" ändert.)
   */
  public registerOnValidatorChange(fn: () => void): void {
    this.#onChange = fn;
  }
}
